import { render, staticRenderFns } from "./Counterparts.vue?vue&type=template&id=c867d180"
import script from "./Counterparts.vue?vue&type=script&lang=js"
export * from "./Counterparts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports